/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Heading, Flex, Stack, Circle, Text } from '@chakra-ui/react';
import { EpisodeSection } from '../../../@types';

export const EpisodePartsNav = ({
  currentSectionIdx,
  sections,
  hideEndScreenOnNavigate = () => {
    //
  },
  isCompleted = false,
}: {
  sections: EpisodeSection[];
  currentSectionIdx: number;
  isCompleted?: boolean;
  hideEndScreenOnNavigate?: () => void;
}) => {
  return (
    <Flex direction="column" align="center">
      <Text color="white" fontWeight={600}>
        Episode parts
      </Text>

      <Stack mt={4} spacing={8} direction="row">
        {sections.map((section, i) => (
          <NavCircle
            key={section.id}
            num={i + 1}
            isCompleted={isCompleted}
            active={i === currentSectionIdx}
            hideEndScreenOnNavigate={hideEndScreenOnNavigate}
          />
        ))}
      </Stack>
    </Flex>
  );
};

const NavCircle = ({
  num,
  hideEndScreenOnNavigate,
  active = false,
  isCompleted = false,
}: {
  num: number;
  active?: boolean;
  isCompleted?: boolean;
  hideEndScreenOnNavigate: () => void;
}) => {
  const history = useHistory();

  const onNavigate = useCallback(() => {
    hideEndScreenOnNavigate();
    window.location.replace(
      `${window.location.href.replace(window.location.search, '')}?part=${num}`
    );
  }, [num, hideEndScreenOnNavigate]);

  return (
    <Circle
      size={10}
      fontSize="lg"
      fontWeight="600"
      color="black"
      borderRadius="full"
      transitionProperty="common"
      transitionDuration="normal"
      {...(active
        ? {
            bg: 'ligthBlue.500',
            borderColor: 'var(--chakra-colors-green-300)',
            borderWidth: '2',
            cursor: 'initial',
          }
        : ({
            onClick: onNavigate,
            opacity: 0.75,
            color: 'ligthBlue.500',
            _hover: {
              opacity: 1,
              cursor: 'pointer',
              bg: 'green.500',
            },
            // eslint-disable-next-line @typescript-eslint/ban-types
          } as {}))}
    >
      {num}
    </Circle>
  );
};
